<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :data-cy="data_cy"
        x-large
        class="custom_button"
        style="
          background-color: white !important;
          border-radius: 5px !important;
          border: 0 solid !important;
        "
        elevation="2"
        @click="$emit('click')"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          class="custom-icon"
          color="
           'rgb(30, 101, 104)'
          "
          >{{ icon }}</v-icon
        >
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
/**
 */

export default {
  name: "ToggleButton",
  props: {
    icon: String,
    tooltip: String,
    data_cy: String,
  }
};
</script>
<style>
.custom_button {
  margin-right: 10px !important;
}
.custom-icon {
  font-size: 26pt !important;
}
</style>
